import { useEffect } from 'react';
import { EventType } from '@azure/msal-browser';
import { clearAllFilterMemory } from '../../../infrastructure/filter-memory-storage';
const useMsalEvents = (msalInstance) => {
    useEffect(() => {
        const callbackId = msalInstance.addEventCallback((event) => {
            if (event.eventType === EventType.LOGOUT_SUCCESS) {
                console.log("Logout complete. Clearing local storage.");
                localStorage.clear();
                // Filter memory lives in sessionStorage (item #2), which localStorage.clear()
                // doesn't touch — without this the next user signing in on this tab would
                // inherit the previous user's filters.
                clearAllFilterMemory();
            }
        });
        // Clean up the event callback on component unmount
        return () => {
            if (callbackId) {
                msalInstance.removeEventCallback(callbackId);
            }
        };
    }, [msalInstance]);
};
export default useMsalEvents;
